export const ELEMENT_TEXT_TRUNCATER = {
  TOOLTIP_WRAPPER: 'elementTextTruncaterTooltipWrapper',
  CLICKABLE_SPAN: 'elementTextTruncaterClickableSpan',
  NON_CLICKABLE_SPAN: 'elementTextTruncaterNonClickableSpan'
} as const;
